import { useCallback, useEffect, useRef } from "react";
import { useBeforeUnload, useBlocker } from "react-router";

/** アプリ内リンク、履歴移動、ページ破棄の前に未保存変更を警告する。 */
export function useUnsavedChangesWarning(enabled: boolean, message: string) {
  const allowNextUnloadRef = useRef(false);
  const blocker = useBlocker(enabled);

  useEffect(() => {
    if (blocker.state !== "blocked") return;
    if (window.confirm(message)) blocker.proceed();
    else blocker.reset();
  }, [blocker, message]);

  useBeforeUnload(
    useCallback(
      (event) => {
        if (!enabled || allowNextUnloadRef.current) return;
        event.preventDefault();
        event.returnValue = "";
      },
      [enabled],
    ),
  );

  return useCallback(
    (action: () => void) => {
      if (enabled && !window.confirm(message)) return;
      allowNextUnloadRef.current = true;
      action();
      window.setTimeout(() => {
        allowNextUnloadRef.current = false;
      }, 0);
    },
    [enabled, message],
  );
}
